const APP_MODE_QUERY_KEYS = ['appMode', 'embeddedApp', 'nativeApp'] as const;
const APP_MODE_STORAGE_KEY = 'sworn_app_mode';
const APP_MODE_USER_AGENT_TOKEN = 'SwornBuilderApp';

const isTruthyFlag = (value: string | null): boolean => {
  if (!value) return false;
  const normalized = value.trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
};

export const isEmbeddedAppMode = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const queryParams = new URLSearchParams(window.location.search);
  for (const key of APP_MODE_QUERY_KEYS) {
    if (isTruthyFlag(queryParams.get(key))) {
      return true;
    }
  }

  try {
    if (isTruthyFlag(window.localStorage.getItem(APP_MODE_STORAGE_KEY))) {
      return true;
    }
  } catch {
    // Ignore storage access errors in restricted browsing contexts.
  }

  const appFlagWindow = window as Window & { __SWORN_APP__?: boolean };
  if (appFlagWindow.__SWORN_APP__ === true) {
    return true;
  }

  return window.navigator.userAgent.includes(APP_MODE_USER_AGENT_TOKEN);
};
